"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeSentry = void 0;
const Sentry = __importStar(require("@sentry/react"));
const initializeSentry = () => {
    let sentryEnvironment;
    switch (window.location.hostname) {
        case "aircasting.org":
            sentryEnvironment = "Production";
            break;
        case "172.104.20.165":
            sentryEnvironment = "Experimental";
            break;
        case "45.56.103.151":
            sentryEnvironment = "Staging";
            break;
        default:
            sentryEnvironment = "Production";
            break;
    }
    if (process.env.NODE_ENV === "production") {
        Sentry.init({
            environment: sentryEnvironment,
            dsn: process.env.SENTRY_DSN_KEY,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            tracesSampleRate: 1.0,
            tracePropagationTargets: [/^http:\/\/localhost(:\d+)?/],
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });
    }
};
exports.initializeSentry = initializeSentry;
